export const ORDER_TYPE_LABELS = {
  DINE_IN: 'Dine-in',
  TAKE_AWAY: 'Take-away',
};

export const formatOrderTypeLabel = (value) => {
  if (!value) return '-';
  const key = String(value).trim().toUpperCase();
  return ORDER_TYPE_LABELS[key] || value;
};
